import { Component, ElementRef, forwardRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  DxNumberBoxComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';
import { AbcCoreComponentService } from '../abcCoreComponent.service';

@Component({
  standalone: true,
  selector: 'abc-number-box',
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => AbcNumberBoxComponent),
    },
  ],
  template: '',
})
export class AbcNumberBoxComponent extends DxNumberBoxComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private abcCoreComponentService: AbcCoreComponentService,
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.stylingMode = this.stylingMode ? this.stylingMode : this.abcCoreComponentService.stylingMode;
    this.labelMode = this.labelMode ?? this.abcCoreComponentService.labelMode;
    const tooltTip = new AbcTooltipDirective(this.element);
    tooltTip.elementClassName = '.dx-texteditor-input';

    this.onInitialized.subscribe(() => {
      this.registerDelKeyAndCleanValue();
    });
  }

  private registerDelKeyAndCleanValue(): void {
    this.instance.registerKeyHandler('del', () => {
      this.value = null;
    });
  }
}
